

import Navbar from './component/Navbar'
import React from 'react'
import MainRoute from './Routes/MainRoute'

const App = () => {
  return (
    <div>
      <Navbar/>
      <MainRoute/>
    </div>
  )
}

export default App
